import React from 'react'
import { Container, Divider, TextField } from '@material-ui/core'
import { isMobile, BrowserView, MobileView } from 'react-device-detect'
import { TextDivider } from '../Core/TextDivier'
import { useForm } from 'react-hook-form'
import { EMAIL_REGEX } from '../../Constants'
import { BottomSheetPolicySummary } from '../Insurance/BottomSheetPolicySummary'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import FlexView from 'react-flexview/lib'
import { GetAQuotePopup } from '../Quote/GetAQuotePopup'
import { Experiment, Variant } from "react-optimize";
import { SessionContextStore } from '../../context/SessionContext'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { awaitWithLoading } from '../../services/utils'
import { useHistory } from 'react-router-dom'


export const PasswordlessEmailForm = () => {
    const sessionContext = React.useContext(SessionContextStore)
    const history = useHistory()
    const { register, triggerValidation, errors, getValues, setError } = useForm()
    const [existsFailure, setExistsFailure] = React.useState(false)

    const onContinue = async () => {
        let valid = await triggerValidation()

        if(!valid) return
        
        let res = await awaitWithLoading(sessionContext.registerPasswordless(getValues().email))

        if(res.ok) {
            EventEmitterService.dispatch(EventKey.FLOW_CUSTOMIZE_FINISH)
        }
        else {
            if(res.parsedData.title == "A user with that email is already registered") {
                setExistsFailure(true)
                setError("email", "email", res.parsedData.title);
            }
            else 
                EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    const goToLogin = () => {
        history.push('/login')
    }

    return (<>
        <Container maxWidth="md" className="margin-top-medium">
            {isMobile && <TextDivider><div className="text-title bold blue">What is your email address?</div></TextDivider>}
            {!isMobile && <> 
                <div className="text-title bold blue margin-top-basic main-title">What is your email address?</div>
                <Divider />
            </>}
            <TextField fullWidth variant="outlined" className="margin-top-basic margin-bottom-basic" label="Email" type="email" name="email" inputRef={register({required: true, pattern: { value: EMAIL_REGEX, message: "Invalid email address"} })}  helperText={!!errors.email && (errors.email.message || errors.email.type)} error={!!errors.email} />
            {existsFailure && <div onClick={goToLogin} className="text-body textcenter blue underline clickable margin-bottom-basic">I already have an account</div>}
            <BrowserView>
                <FlexView vAlignContent={'center'} className="margin-top-small margin-bottom-basic">
                    <ContinueButton onClick={onContinue} />
                    <div className="margin-left-12"> <GetAQuotePopup /> </div>
                </FlexView>
            </BrowserView>
        </Container>
        <MobileView>
            <BottomSheetPolicySummary  title={'Continue'} onClick={onContinue} />
        </MobileView>

    </>)
}